module.exports = __webpack_public_path__ + "static/media/ru.ca0208a9.svg";